import { render, staticRenderFns } from "./VBarItem.vue?vue&type=template&id=1c53e10c&scoped=true&"
import script from "./VBarItem.vue?vue&type=script&lang=ts&"
export * from "./VBarItem.vue?vue&type=script&lang=ts&"
import style0 from "./VBarItem.vue?vue&type=style&index=0&id=1c53e10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53e10c",
  null
  
)

export default component.exports